import {
  Button,
  Divider,
  IconButton,
  Icons,
  ExternalLink,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

import { TerraformSvg } from 'assets/svg';

import { EXTERNAL_LINKS } from '@cast/constants';

type Props = {
  onClose: () => void;
  hideTerraformLink?: boolean;
};

export const ClusterDialogHeaderActions = ({
  onClose,
  hideTerraformLink,
}: Props) => {
  return (
    <Stack direction="row" alignItems="center" height={28}>
      {hideTerraformLink ? null : (
        <>
          <Button
            variant="text"
            component={ExternalLink}
            link={EXTERNAL_LINKS.castai_terraform}
            startIcon={<TerraformSvg />}
            noIcon
          >
            Terraform
          </Button>
          <Divider
            orientation="vertical"
            color={colorOrToken(
              'grey.300',
              tokens.theme.border.structural.neutralStrong
            )}
            sx={{
              height: 22,
              mx: 8,
            }}
          />
        </>
      )}

      <IconButton variant="ghost" size="sm" onClick={onClose}>
        <Icons.X />
      </IconButton>
    </Stack>
  );
};
